const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
  debug: (...args) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  trace: (...args) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  info: (...args) => {
    console.log(...args);
  },
  warn: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  }
};

export default logger;
